import {createSlice} from '@reduxjs/toolkit';
import {QuestionDeatilsDto} from 'src/shared/services/questions-management/dto/question-details-dto';

interface QuestionsManagementInitialState {
  questionsList: Array<QuestionDeatilsDto> | undefined;
  questionDetails: QuestionDeatilsDto | undefined;
  isQuestionsListLoading: boolean | undefined;
}

const initialState: QuestionsManagementInitialState = {
  questionsList: [],
  questionDetails: undefined,
  isQuestionsListLoading: false,
};

const questionsManagementSlice = createSlice({
  name: 'questionsManagement',
  initialState: initialState,
  reducers: {
    setQuestionsList: (state, action) => {
      state.questionsList = action.payload;
    },
    setQuestionDetails: (state, action) => {
      state.questionDetails = action.payload;
    },
    setIsQuestionsListLoading: (state, action) => {
      state.isQuestionsListLoading = action.payload;
    },
  },
});

export const {setQuestionsList, setQuestionDetails, setIsQuestionsListLoading} =
  questionsManagementSlice.actions;

export default questionsManagementSlice.reducer;
